import { MAIN_CHART_STORAGE_KEYS } from '@/lib/localStorageKeys/main-chart';
import { DEFAULT_MAIN_CHART } from './default-data';
import { MainChart } from './types';

export const getStoredMainChart = (): MainChart | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const storedData = localStorage.getItem(MAIN_CHART_STORAGE_KEYS.CORE);
    
    if (!storedData) {
      // Return null if no data exists
      return null;
    }

    const parsedData = JSON.parse(storedData);
    
    // Merge with defaults to ensure all fields exist
    return {
      ...DEFAULT_MAIN_CHART,
      ...parsedData,
    };
  } catch (error) {
    console.error('Error loading main chart from localStorage:', error);
    return null;
  }
};

export const getStoredMainChartOrDefault = (): MainChart => {
  const stored = getStoredMainChart();
  if (!stored) {
    // If no main chart data exists, save and return defaults
    saveMainChart(DEFAULT_MAIN_CHART);
    return DEFAULT_MAIN_CHART;
  }
  return stored;
};

export const saveMainChart = (mainChart: MainChart): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(MAIN_CHART_STORAGE_KEYS.CORE, JSON.stringify(mainChart));
  } catch (error) {
    console.error('Error saving main chart to localStorage:', error);
  }
};

/**
 * Get the size of stored main chart in bytes
 * @returns Size in bytes or 0 if not found
 */
export function getStoredMainChartValue(): number {
  if (typeof window === 'undefined') return 0;
  
  try {
    const stored = localStorage.getItem(MAIN_CHART_STORAGE_KEYS.CORE);
    
    if (!stored) return 0;
    
    // Calculate size in bytes (JavaScript strings are UTF-16, so each character is 2 bytes)
    return stored.length * 2;
  } catch (error) {
    console.error('Error getting main chart size:', error);
    return 0;
  }
}

/**
 * Clear stored main chart
 * @returns Success status
 */
export function clearStoredMainChart(): boolean {
  if (typeof window === 'undefined') return false;
  
  try {
    localStorage.removeItem(MAIN_CHART_STORAGE_KEYS.CORE);
    return true;
  } catch (error) {
    console.error('Error clearing main chart:', error);
    return false;
  }
}